import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DialogsService } from '../../services/dialogs.service';
import { UserProfileService } from '../../services/users/user-profile.service';
import { ChatBlipComponent } from './chat-blip.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [ ChatBlipComponent ],
    declarations: [ ChatBlipComponent ],
    entryComponents: [ ChatBlipComponent ],
    providers: [ 
        UserProfileService,
        DialogsService
    ]
})
export class ChatBlipModule {}